import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Address, User} from '../../types/models';
import {UserService} from '../../services/customer/user.service';
import {AddressService} from '../../services/customer/address.service';

@Component({
  selector: 'app-profile-completion-modal',
  templateUrl: './profile-completion-modal.page.html',
  styleUrls: ['./profile-completion-modal.page.scss'],
})
export class ProfileCompletionModalPage implements OnInit {

  user: User = { FirstName: '', LastName: '', Phone: '' };
  address: Address = { Street: '', City: '', Zip: '', Name: '' };

  firstNameValidation: { Valid: boolean; Messages: string[] } = { Valid: true, Messages: [] };
  lastNameValidation: { Valid: boolean; Messages: string[] } = { Valid: true, Messages: [] };
  phoneValidation: { Valid: boolean; Messages: string[] } = { Valid: true, Messages: [] };
  addressErrorMessage: string;
  loading: boolean;

  constructor(
    private modalController: ModalController,
    private userService: UserService,
    private addressService: AddressService,
  ) { }

  async ngOnInit() {
    this.loading = true;
    const user = await this.userService.get();
    this.user = { ...this.user, ...user };
    this.updateFirstNameValidation();
    this.updateLastNameValidation();
    this.updatePhoneValidation();
    this.loading = false;
  }

  updateFirstNameValidation() {
    this.firstNameValidation = this.userService.nameValidation(this.user?.FirstName);
  }

  updateLastNameValidation() {
    this.lastNameValidation = this.userService.nameValidation(this.user?.LastName);
  }

  updatePhoneValidation() {
    this.phoneValidation = this.userService.phoneValidation(this.user?.Phone);
  }

  get profileValid(): boolean {
    return this.firstNameValidation.Valid && this.lastNameValidation.Valid && this.phoneValidation.Valid;
  }

  async save() {
    if (this.loading || !this.profileValid) {
      return;
    }
    this.loading = true;
    this.addressErrorMessage = null;
    const userSaved = await this.userService.save(this.user);
    if (!userSaved) {
      this.loading = false;
      return;
    }
    const response = await this.addressService.saveDelivery(this.address);
    if (!response.Success) {
      this.loading = false;
      this.addressErrorMessage = response.Message || 'not found';
      return;
    }
    await this.addressService.setSelectedDeliveryAddressAndFindStore(response.Address);
    this.loading = false;
    await this.modalController.dismiss({ Completed: true });
  }
}
